import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Background mesh gradient */}
      <div className="absolute inset-0 bg-mesh opacity-60"></div>
      {/* Subtle dot pattern overlay */}
      <div className="absolute inset-0 dot-pattern opacity-[0.4]"></div>
      {/* Section divider line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/50 to-transparent"></div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 relative">
        <div className="mb-14">
          <h2 className="font-heading font-light text-[32px] md:text-[36px] text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            Browse thousands of CSSBuy spreadsheet finds across {categories.length} categories
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <div
              key={cat.name}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 relative"
            >
              <div className="h-[140px] md:h-[170px] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={'CSSBuy Spreadsheet ' + cat.name + ' category'}
                  title={'CSSBuy Spreadsheet ' + cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-3 whitespace-nowrap">
                  {cat.name}
                </h3>
                <a
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className={'inline-flex items-center justify-center w-[80%] py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ' + (idx === 0
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'border border-foreground-200 text-foreground-700 hover:bg-background-100')}
                >
                  Browse
                  <i className="ri-arrow-right-up-line ml-1.5 text-sm"></i>
                </a>
                <p className="mt-2 text-[11px] md:text-xs text-foreground-400">
                  {cat.itemCount}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}